import {
  pickAssistantMessageMetaFromResult,
  resolveThoughtSummaryWithDuration,
} from '@/services/chatApi'
import { dedupeStrings } from '../../backendRunProgressUtils'

const MAX_TRACE_ROWS = 40

/** @param {unknown[]} list @param {string} pendingId @param {import('@/services/chatApi').ChatCompletionResult} result */
export function patchPendingFromCompletion(list, pendingId, result) {
  const idx = list.findIndex((msg) => msg.id === pendingId)
  if (idx === -1) return null
  const next = [...list]
  let textOut = result.text
  if (!result.ok) {
    textOut = `Could not get a reply.\n\n${result.message}`
    if (result.code === 'AETHER_ERROR') textOut = result.message
  }
  const assistantMeta = result.ok ? pickAssistantMessageMetaFromResult(result) : {}
  const prevRow = list[idx]
  const mergedTraceMeta = mergeCompletionTrace(prevRow, assistantMeta)
  const mergedAssistantMeta = { ...assistantMeta, ...mergedTraceMeta }
  const blocksFromApi =
    result.ok && Array.isArray(result.blocks) && result.blocks.length ? result.blocks : null
  next[idx] = {
    ...next[idx],
    text: textOut,
    createdAt: Date.now(),
    ...mergedAssistantMeta,
    autoExpandPreamble: false,
    ...(result.ok
      ? { thoughtSummary: resolveThoughtSummaryWithDuration(prevRow, mergedAssistantMeta) }
      : {}),
    ...(blocksFromApi ? { blocks: blocksFromApi } : {}),
  }
  return next
}

function mergeCompletionTrace(prevRow, assistantMeta) {
  const liveDetails = Array.isArray(prevRow?.thoughtDetails) ? prevRow.thoughtDetails : []
  const finalDetails = Array.isArray(assistantMeta?.thoughtDetails) ? assistantMeta.thoughtDetails : []
  const thoughtDetails = dedupeStrings([...liveDetails, ...finalDetails]).slice(-MAX_TRACE_ROWS)
  const liveIds = Array.isArray(prevRow?.streamProgressEventIds) ? prevRow.streamProgressEventIds : []
  const finalIds = Array.isArray(assistantMeta?.streamProgressEventIds)
    ? assistantMeta.streamProgressEventIds
    : []
  const streamProgressEventIds = dedupeStrings([...liveIds, ...finalIds]).slice(-MAX_TRACE_ROWS)
  return {
    ...(thoughtDetails.length ? { thoughtDetails } : {}),
    ...(streamProgressEventIds.length ? { streamProgressEventIds } : {}),
  }
}
